import { render, staticRenderFns } from "./BalanceOutputNoticeWithCard.vue?vue&type=template&id=b8946d8c&scoped=true"
import script from "./BalanceOutputNoticeWithCard.vue?vue&type=script&lang=js"
export * from "./BalanceOutputNoticeWithCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceOutputNoticeWithCard.vue?vue&type=style&index=0&id=b8946d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8946d8c",
  null
  
)

export default component.exports